export function getLabelByName(name, schema) {
    let foundIndex = schema.findIndex(i => i.name === name);
    return foundIndex !== -1 ? schema[foundIndex].label : '';
}